//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
export default {
  props: {
    value: { type: String },
    label: { type: String },
    disabled: { type: Boolean },
    errorMessages: { type: [String, Array] },
    seconds: { type: Boolean, default: false },
  },
  data() {
    return {
      menu: false,
      maxTime: null,
    };
  },
  watch: {
    menu: function () {
      this.maxTime = moment().format("HH:mm");
    },
  },
  computed: {
    time: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
};
